module.exports = __webpack_public_path__ + "static/media/viaje.c9b04fe1.png";